'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/Broadcast.js";
var c = Object.defineProperty, f = Object.defineProperties;
var i = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var e = (r, o, a) => o in r ? c(r, o, { enumerable: true, configurable: true, writable: true, value: a }) : r[o] = a, m = (r, o) => {
  for (var a in o || (o = {}))
    p.call(o, a) && e(r, a, o[a]);
  if (t)
    for (var a of t(o))
      d.call(o, a) && e(r, a, o[a]);
  return r;
}, s = (r, o) => f(r, i(o));
const I = forwardRef((r, o) => /* @__PURE__ */ a__default.createElement(b, s(m({ ref: o }, r), { weights: t$1 })));
I.displayName = "Broadcast";
export {
  I as Broadcast
};
